import { AfterViewInit, Component, DestroyRef, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { isPlatformServer } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { skip } from 'rxjs';
import { GoogleTagManagerService, NetworkService, OneTrustService } from '@pro-connect/shared';
import { Angulartics2GoogleAnalytics, Angulartics2GoogleTagManager } from 'angulartics2';

@Component({
  selector: 'www-root',
  template: ` <router-outlet class="www-root" /> `,
  imports: [RouterModule],
  styles: [
    `
      ::ng-deep .www-root + * {
        display: block;
        animation: fade 0.25s;
        height: 100%;

        @keyframes fade {
          from {
            opacity: 0;
          }

          to {
            opacity: 1;
          }
        }
      }
    `,
  ],
})
export class AppComponent implements OnInit, AfterViewInit {
  constructor(
    private readonly _ngbModal: NgbModal,
    private readonly _router: Router,
    @Inject(PLATFORM_ID)
    private readonly _platformId: string,
    private readonly _networkService: NetworkService,
    private readonly _destroyRef: DestroyRef,
    private readonly _toastrService: ToastrService,
    private readonly _oneTrustService: OneTrustService,
    private readonly _googleTagManagerService: GoogleTagManagerService,
    private readonly _angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    private readonly _angulartics2GoogleTagManager: Angulartics2GoogleTagManager,
  ) {}

  public ngOnInit(): void {
    this._setRouterSubscription();
    this._setOnlineOfflineChangesSubscription();
  }

  public ngAfterViewInit(): void {
    this._oneTrustService.addScriptToDom().then(() => {
      this._googleTagManagerService.addScriptToDom().then(() => {
        this._angulartics2GoogleAnalytics.startTracking();
        this._angulartics2GoogleTagManager.startTracking();
      });
    });
  }

  private _setOnlineOfflineChangesSubscription(): void {
    if (isPlatformServer(this._platformId)) {
      return;
    }
    this._networkService.onlineChanges$.pipe(takeUntilDestroyed(this._destroyRef), skip(1)).subscribe((online) => {
      if (online) {
        this._toastrService.info('Twoje połączenie z internetem zostało przywrócone.');
      } else {
        this._toastrService.warning('Twoje połączenie z internetem zostało utracone.');
      }
    });
  }

  private _setRouterSubscription(): void {
    if (isPlatformServer(this._platformId)) {
      return;
    }
    this._router.events.subscribe((routeEvent) => {
      if (routeEvent instanceof NavigationEnd) {
        this._ngbModal.dismissAll();
      }
    });
  }
}
